module.exports = "https://cdn.realtymogul.com/static/media/panel_JVEquity.feb34eee.jpg";